export const paths = ['/esub-drive', '/esub-drive/:fileId/view'];
